import { ExternalBlogMedia } from 'src/types';
import Link from 'next/link';

const BlogMedia: React.FC<{ media: ExternalBlogMedia; index: number; numClassName?: string }> = ({
  media,
  index,
  numClassName,
}) => {
  return (
    <div className="blog__list-item-text">
      <div className={`blog__list-item-num ${numClassName || ''}`}>{index + 1}</div>
      <div className="blog__list-item-body">
        <h3 className="blog__list-item-title">{media.title}</h3>
        <div
          className="blog__list-item-desc"
          dangerouslySetInnerHTML={{ __html: media.bodyHtml || '' }}
        ></div>
        {media.optionEmbed ? (
          <div className="blog__list-item-btn-book tw-mt-4">
            {media.link ? (
              <Link legacyBehavior prefetch={false} href={media.link}><a className="tw-text-brand-navy tw-underline tw-font-styleSans tw-font-semibold">read more</a></Link>
            ) : (
              <a className="tw-text-brand-navy tw-underline tw-font-semibold tw-font-styleSans js-oembed-btn-book-now">read more</a>
            )}
          </div>
        ) : media.link ? (
          <div className="blog__list-item-link tw-mt-4">
            <Link legacyBehavior prefetch={false} href={media.link || '#'}>
              <a className="tw-text-brand-navy tw-underline tw-font-styleSans tw-font-semibold">view more</a>
            </Link>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default BlogMedia;
